import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';

import { Http } from '@angular/http';
import { URLSearchParams } from '@angular/http';

export class ConcedenteFiltro {
  nome: string;
  tipoConcedente: string;
  pagina = 0;
  itensPorPagina = 10;
}

@Injectable()
export class OrgaoService {

  apiUrl = environment.apiUrl;

  constructor(private http: Http) { }

  listarOrgao (): Promise<any> {
    const params = new URLSearchParams();
    params.set('page','0');
    params.set('size', '100');

    return this.http.get(`${this.apiUrl}/entidade-concedente/concedentes-publicos`, { search: params })
      .toPromise()
      .then(response => response.json().content);
  }
  
  pesquisar(filtro: ConcedenteFiltro): Promise<any> {
    const params = new URLSearchParams();

    params.set('page', filtro.pagina.toString());
    params.set('size', filtro.itensPorPagina.toString());

    if (filtro.nome) {
      params.set('nome', filtro.nome);
    }
    if (filtro.tipoConcedente) {
      params.set('tipoConcedente', filtro.tipoConcedente);
    }

    return this.http.get(`${this.apiUrl}/entidade-concedente/concedentes-publicos`, { search: params })
      .toPromise()
      .then(response => {
        return response.json();
      })
  }
}

